<template>
	<div class="os-container">
		<div class="os">
			<!-- 顶部栏 -->
			<div class="top">
				<div class="top-logo"></div>
				<div class="top-title">大数据可视化分析平台</div>
				<div class="top-left">
					<div class="top-btn home"
					    @click="backHome">
						<common-icon :size="dp2p(28)"
						    :color="theme.osPrimaryColor"
						    type="_shouye" /><span class="top-btn-label">回到首页</span>
					</div>
				</div>
				<div class="top-right">
					<div class="top-btn tongzhi">
						<common-icon :size="dp2p(28)"
						    :color="theme.osPrimaryColor"
						    type="_tongzhi" />
						<div class="top-btn-badge">{{ toReceiveCount > 99 ? '99+' : toReceiveCount }}</div>
					</div>
					<div class="top-btn shijian">
						<common-icon :size="dp2p(28)"
						    :color="theme.osPrimaryColor"
						    type="_shijian" /><span class="top-btn-label">
							<time-clock /></span>
					</div>
				</div>
			</div>
			<template v-if="init">
				<!-- 左侧图表 -->
				<div class="chart side x-1 y-1 img-border">
					<div class="overview-tag">年度</div>
					<chart-order-overview :total="overviewByYear.total"
					    :finished="overviewByYear.finished"
					    :orderDataSource="overviewByYear.orderDataSource"
					    time-range="year" />
				</div>
				<div class="chart side x-1 y-2 img-border">
					<chart-service-count :list="serviceTypeCountByYear"
					    time-range="year" />
				</div>
				<div class="chart side x-1 y-3 img-border">
					<chart-service-status :list="serviceTypeStatusByYear"
					    time-range="year" />
				</div>
				<!-- 中央工单列表 -->
				<div class="os-order x-2">
					<trans-switch-list>
						<div class="os-order-list"
						    :key="batchId">
							<order-item v-for="item in batchOrder"
							    :key="item.id"
							    :order="item"
							    @click.native="showOrder(item)" />
						</div>
					</trans-switch-list>
				</div>
				<div class="chart middle x-2 y-3 img-border">
					<chart-full-status :list="serviceTypeStatusFullYear"
					    time-range="year" />
				</div>
				<!-- 右侧图表 -->
				<div class="chart side x-3 y-1 img-border">
					<div class="overview-tag">月度</div>
					<chart-order-overview :total="overviewByMonth.total"
					    :finished="overviewByMonth.finished"
					    :orderDataSource="overviewByMonth.orderDataSource"
					    time-range="month" />
				</div>
				<div class="chart side x-3 y-2 img-border">
					<chart-service-count :list="serviceTypeCountByMonth"
					    time-range="month" />
				</div>
				<div class="chart side x-3 y-3 img-border">
					<chart-service-status :list="serviceTypeStatusByMonth"
					    time-range="month" />
				</div>
			</template>
		</div>
		<!-- 工单详情 -->
		<smart-modal v-model="showDetail"
		    maskClosable
		    background="transparent"
		    :async="false"
		    :closable="false"
		    :width='dp2p(720)'
		    :height='dp2p(840)'
		    :buttons="[]"
		    @on-hidden="onDetailHidden">
			<order-detail v-if="showDetail"
			    :id="curId" />
		</smart-modal>
	</div>
</template>
<script>
// components
import ChartOrderOverview from '../charts/order-overview'
import ChartServiceCount from '../charts/service-count'
import ChartServiceStatus from '../charts/service-status'
import ChartFullStatus from '../charts/full-status'
import OrderItem from '../components/order-item'
import OrderDetail from '../components/order-detail'
import TimeClock from '_c/time-clock'
import TransSwitchList from '../transition/switch-list'
// mixin
import OsOrder from '../components/os-order'

// 工单数字大屏
export default {
	name: "OsDefault",

	mixins: [OsOrder],

	components: {
		ChartOrderOverview,
		ChartServiceCount,
		ChartServiceStatus,
		ChartFullStatus,
		OrderItem,
		OrderDetail,
		TimeClock,
		TransSwitchList,
	},

	data() {
		return {
			showDetail: false,
			curId: '',
		}
	},

	methods: {
		showOrder(item) {
			this.showDetail = true
			this.curId = item.id
			// 停止工单滚动
			this.stopSwitch()
		},

		onDetailHidden() {
			this.startSwitch()
		}
	}
}
</script>
<style lang="less"
    scoped>
@import '../components/os.less';

// customize
</style>